import { Box, Stack, useTheme } from '@mui/material'
import { grey } from '@mui/material/colors'
import { makeStyles } from '@mui/styles'
import { useEffect, useState } from 'react'
import BodySkeleton from '../../../../common/skeletons/BodySkeleton'
import { getExpenseHistory, getExpenseHistoryLabels } from '../expenseHistory'
import Table from '../Table'

export default function ContentBody() {

    const [loading, setLoading] = useState(true)
    const theme = useTheme()

    useEffect(()=>{

        setTimeout(()=>{
            setLoading(false)
        }, 1000)

    },[])

    const useStyles = makeStyles({
        content:{
            flex: 1, 
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            borderRadius: "4px", 
            minHeight: "420px", 
            backgroundColor: theme.palette.primary.main,
            padding: "1rem"
        },
        searchField:{
            backgroundColor: theme.palette.primary.dark,
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            padding: ".3rem",
            borderRadius: "3px",
            color: grey[200],
            fontWeight: "regular",
            fontSize: "14px",
            outline: "none"
        }
    })

    const classes = useStyles()
    
    return (
        <>
            {
                loading ? (
                    <BodySkeleton />
                ):(

                    <Box className={classes.content} >

                        <Stack
                            sx={{height: "100%"}}
                            direction="column"
                            spacing={2}
                        >


                            <Table 
                                title="Expenses history"
                                tableBodyData={getExpenseHistory()}
                                tableHeadData={getExpenseHistoryLabels()}
                                handleItemClick={()=>{}}
                            />


                        </Stack>

                        
                    </Box>
                    
                )
            }
        </>
    )
}
